module.exports = __webpack_public_path__ + "img/solved.fab0bd25.png";